
import Cookies from 'js-cookie'
// cookie保存的天数
const inFifteenMinutes = new Date(new Date().getTime() + 15 * 60 * 1000)


export const setToken = (token) => {
  Cookies.set('token', token, {expires: inFifteenMinutes})
}

export const setAppid = (token) => {
  Cookies.set('appid', token, {expires: inFifteenMinutes || 1})
}

export const setShareId = (id) => {
  Cookies.set('share_userid', id, {expires: inFifteenMinutes || 1})
}

export const setOpenid = (token) => {
  Cookies.set('openid', token, {expires: inFifteenMinutes || 1})
}

export const setWetchInfo = (info) => {
  Cookies.set('wetchinfo', JSON.stringify(info), {expires: 1})
}

export const setRegisterPhone = (token) => {
    Cookies.set('registerphone', token, {expires: inFifteenMinutes || 1})
  }

export const getToken = () => {
  const token = Cookies.get('token')
  if (token) return token
  else return false
}

export const getWetchInfo = () => {
  const info = Cookies.get('wetchinfo')
  return info ? JSON.parse(info) : ''
}

export const getIsRegister = () => {
    const val = Cookies.get('registerphone')
    if (val) return val
    else return false
}

export const getShareId = () => {
  const val = Cookies.get('share_userid')
  if (val) return val
  else return false
}



// WEBPACK FOOTER //
// ./src/utils/cookie.js